<template>
    <v-card outlined elevation="0" class="rounded v-application">
        <v-card-title>Adresse</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>
                <v-col>
                    <div id="map" class="mb-3"></div>
                    <v-btn
                        :href="`/users/admin?city=${pharmacy.city}`"
                        target="_blank"
                        :title="`Umkreissuche nach Freiberuflern in ${pharmacy.zip} ${pharmacy.city}`"
                        small
                    >
                        <v-icon class="mr-2" small>mdi-magnify</v-icon> Umkreissuche
                    </v-btn>
                    <v-btn
                        @click="updateGeolocation"
                        :loading="isLoading"
                        class="ml-3"
                        color="cyan lighten-1"
                        dark
                        small
                    >
                        <v-icon class="mr-2" small>mdi-update</v-icon>
                        <span>Geolokalisierung aktualisieren</span>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <div class="h5 mb-2"><strong>Adresse</strong></div>
                    <ul>
                        <li> {{ gender }} {{pharmacy.owner}}</li>
                        <li>{{pharmacy.street}}</li>
                        <li class="mb-4">{{pharmacy.zip}} {{pharmacy.city}}</li>
                    </ul>
                </v-col>
                <v-col>
                    <div class="h5 mb-2"><strong>Rechnungsadresse</strong></div>
                    <ul>
                        <li> {{ gender }} {{pharmacy.owner}}</li>
                        <li>{{pharmacy.billing_street}}</li>
                        <li>{{pharmacy.billing_zip}} {{pharmacy.billing_city}}</li>
                    </ul>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from "axios";
import L from "leaflet"
import { mapMutations } from 'vuex';
import { osmTileLayer } from '../../../../osm-tile-layer.js';

delete (L.Icon.Default.prototype)._getIconUrl;

L.Marker.prototype.setIcon(L.icon({
    iconUrl: '../static/images/marker-icon.png',
    iconAnchor: [16, 32],
    shadowUrl: '../static/images/marker-shadow.png',
}))

export default {
    props: {
        pharmacy: Object
    },
    data() {
        return {
            isLoading: false,
            map: null,
            marker: null
        }
    },
    methods: {
        async updateGeolocation() {
            this.isLoading = true;
            try {
                const response = await axios.put('/api/pharmacies/geolocation', {
                    ids: [this.pharmacy._id]
                });

                const result = response.data[0]
                const latlng = [result.new_coordinates.latitude, result.new_coordinates.longitude];
                this.map.flyTo(latlng);
                this.marker.setLatLng(latlng);
                this.alertSuccess("erfolgreich aktualisiert");

            } catch (error) {
                this.alertError();
            } finally {
                this.isLoading = false;
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
            alertSuccess: 'alert/success',
        })
    },
    mounted() {
        this.$nextTick(() => {
            const coordinates = [...this.pharmacy.location.coordinates].reverse();
            this.map = L.map("map").setView(coordinates, 15);

            osmTileLayer(L, 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);
            this.marker = L.marker(coordinates).addTo(this.map);
        })
    }
}
</script>

<style scoped>
#map {
    height: 300px;
}
</style>